import { PublicBrokerAdvertiserInfoDto, PublicLinkCustomerDto } from '@base/backend';

export function getAdvertiserInfo(servoAdvertiserId: string | null): PublicBrokerAdvertiserInfoDto {
  return {
    advertiserId: servoAdvertiserId ?? ''
  };
}

export function getPublicLinkCustomerDto(): PublicLinkCustomerDto {
  const url = new URL(window.location.href);
  const customerId = url.searchParams.get('customerId');
  const personId = url.searchParams.get('personId');

  if (!customerId || !personId) {
    throw new Error('CustomerId or personId not found in URL parameters.');
  }

  return {
    customerId: customerId!,
    personId: personId!
  };
}
